import {InitatePropertiesDataService} from "./initate-properties-data.service";
import {SingleEntityService} from "../../single-entities/single-entity.service";

export class BaseEntityPropertiesGenerator {
  constructor(protected propsGenerator: InitatePropertiesDataService, protected singleEntityService: SingleEntityService,
  ) {
  }
}
